import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TRUE } from '../../../utils/config/const';

@Component({
  selector: 'app-update-whatsapp-modal',
  templateUrl: './update-whatsapp-modal.component.html'
})
export class UpdateWhatsappModalComponent implements OnInit {

  formBuilder: FormGroup;
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(){
    this.formBuilder = this.fb.group({
      whatsapp:new FormControl('', [Validators.required, Validators.pattern("[0-9]*"), Validators.maxLength(13)]),
    });
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }
  get whatsapp(){return this.formBuilder.get('whatsapp');}


  clickButtonSave(){
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.activeModal.close(this.formBuilder.controls['whatsapp'].value);
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }

}
